export const SET_CONTACTS = 'setContacts'
export const SET_CONTACTS_LOADING = 'setContactsLoading'